export const RESEARCH_REASONING_EFFORTS = [
  'none',
  'minimal',
  'low',
  'medium',
  'high',
  'xhigh',
  'max',
] as const;

export type ResearchReasoningEffort = (typeof RESEARCH_REASONING_EFFORTS)[number];

export const DEFAULT_RESEARCH_REASONING_EFFORT: ResearchReasoningEffort = 'medium';
export const ONBOARDING_RESEARCH_REASONING_EFFORT: ResearchReasoningEffort = 'medium';
export const RESEARCH_REASONING_EFFORT_STORAGE_KEY = 'attune.research.reasoningEffort.v1';
export const RESEARCH_REASONING_EFFORT_EVENT = 'attune:research-reasoning-effort';

export function resolveResearchReasoningEffort(
  value: unknown
): ResearchReasoningEffort | undefined {
  return typeof value === 'string' &&
    RESEARCH_REASONING_EFFORTS.includes(value as ResearchReasoningEffort)
    ? (value as ResearchReasoningEffort)
    : undefined;
}

export function resolveSupportedResearchReasoningEffort(
  supportedEfforts: readonly ResearchReasoningEffort[],
  value: unknown
): ResearchReasoningEffort | undefined {
  if (supportedEfforts.length === 0) return undefined;
  const requested = resolveResearchReasoningEffort(value);
  if (requested && supportedEfforts.includes(requested)) return requested;
  if (supportedEfforts.includes(DEFAULT_RESEARCH_REASONING_EFFORT)) {
    return DEFAULT_RESEARCH_REASONING_EFFORT;
  }
  return supportedEfforts[0];
}

export function getStoredResearchReasoningEffort(): ResearchReasoningEffort {
  if (typeof window === 'undefined') return DEFAULT_RESEARCH_REASONING_EFFORT;
  return (
    resolveResearchReasoningEffort(
      window.localStorage.getItem(RESEARCH_REASONING_EFFORT_STORAGE_KEY)
    ) || DEFAULT_RESEARCH_REASONING_EFFORT
  );
}
